import axios from '@/utils/request';

export default function configAxios() {
  return function(store) {
    Object.defineProperties(store, {
      axios: {
        get() {
          return axios;
        },
      },

      $http: {
        get() {
          return axios;
        },
      },
    });
  };
}
